<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        v-if="!isPrint"
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12 sm12 md6>
                            <table class="lstTable tranferTable">
                                <tr>
                                    <td width="50%" style="text-align: center">Mã quản lý</td>
                                    <td width="50%" style="text-align: center" v-if="isUpdate">
                                        {{ this.getFixedAssetsCode() }}
                                    </td>
                                    <td width="50%" v-else>
                                        <v-autocomplete
                                            :items="lstFixedAssets"
                                            v-model="createItem.fixedAssetsId"
                                            name="fixedAssetsId"
                                            item-value="id"
                                            item-text="code"
                                            v-validate="'required'"
                                            :data-vv-as="$t('Mã quản lý')"
                                            :error-messages="errors.first('fixedAssetsId')"
                                            @change="onChangeFixedAssets($event)"
                                            clearable
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Tên tài sản</td>
                                    <td style="text-align: center">{{ this.getFixedAssetsName() }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Ngày điều chuyển</td>
                                    <td style="text-align: center" v-if="isUpdate">{{ this.formatDate(createItem.tranferDate) }}</td>
                                    <td v-else>
                                        <i-datepicker 
                                            v-model="createItem.tranferDate"
                                            :v-validate="'required'"
                                            :error-messages="errors.first($t('Ngày điều chuyển'))"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Kho hiện tại</td>
                                    <td style="text-align: center">{{ this.getWarehouseName(createItem.warehouseCurrent) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Bộ phận sử dụng hiện tại</td>
                                    <td style="text-align: center">{{ this.getDepartmentName(createItem.departmentCurrent) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Địa điểm sử dụng hiện tại</td>
                                    <td style="text-align: center">{{ this.getLocationName(createItem.locationCurrent) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Kho nhận điều chuyển</td>
                                    <td style="text-align: center" v-if="isUpdate">{{ this.getWarehouseName(createItem.warehouseNew) }}</td>
                                    <td v-else>
                                        <v-autocomplete
                                            :items="lstWarehouse"
                                            v-model="createItem.warehouseNew"
                                            name="warehouseNew"
                                            item-value="categoryId"
                                            item-text="categoryName"
                                            v-validate="'required'"
                                            :data-vv-as="$t('Kho nhận điều chuyển')"
                                            :error-messages="errors.first('warehouseNew')"
                                            clearable
                                            :disabled="isUpdate"
                                            @change="onChangeWh"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Bộ phận nhận điều chuyển</td>
                                    <td style="text-align: center" v-if="isUpdate">{{ this.getDepartmentName(createItem.departmentNew) }}</td>
                                    <td v-else>
                                        <v-autocomplete
                                            :items="lstDepartment"
                                            v-model="createItem.departmentNew"
                                            name="departmentNew"
                                            item-value="deptId"
                                            item-text="deptName"
                                            v-validate="'required'"
                                            :data-vv-as="$t('Bộ phận nhận điều chuyển')"
                                            :error-messages="errors.first('departmentNew')"
                                            clearable
                                            :disabled="isUpdate"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Địa điểm nhận điều chuyển</td>
                                    <td style="text-align: center" v-if="isUpdate">{{ this.getLocationName(createItem.locationNew) }}</td>
                                    <td v-else>
                                        <v-autocomplete
                                            :items="lstLocation"
                                            v-model="createItem.locationNew"
                                            name="locationNew"
                                            item-value="categoryId"
                                            item-text="categoryName"
                                            v-validate="'required'"
                                            :data-vv-as="$t('Địa điểm nhận điều chuyển')"
                                            :error-messages="errors.first('locationNew')"
                                            clearable
                                            :disabled="isUpdate"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Nội dung</td>
                                    <td style="text-align: center" v-if="isPrint">{{ createItem.note }}</td>
                                    <td v-else>
                                        <v-textarea
                                            rows="2"
                                            v-model="createItem.note"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: center">Tình trạng tài sản</td>
                                    <td style="text-align: center" v-if="isPrint">{{ createItem.statusCurrent }}</td>
                                    <td v-else>
                                        <v-textarea
                                            rows="2"
                                            v-model="createItem.statusCurrent"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions v-if="!isPrint">
                    <v-flex xs12 sm12 md6 style="padding-left: 10px; text-align: right;">
                        <v-spacer />
                        <v-btn color="success" @click="onSavePrint" :disabled="loading">
                            {{ $t("lang.common.print") }}
                        </v-btn>
                        <v-btn v-if="isUpdate" color="primary" @click="onSave" :disabled="loading">
                            {{ $t("lang.common.update") }}
                        </v-btn>
                        <v-btn v-else color="primary" @click="onSave" :disabled="loading">
                            {{ $t("lang.common.save") }}
                        </v-btn>
                        <v-btn color="error" @click="onCancel" :disabled="loading">
                            {{ $t("lang.common.cancel") }}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import { cateContants } from "@/constants";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "fixed-assets-tranfer-create",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Biên bản bàn giao",
            loading: false,
            fixedAssetsName: '',
            createItem: {
                fixedAssetsId: '',
                tranferDate: '',
                locationCurrent: '',
                departmentCurrent: '',
                locationNew: '',
                departmentNew: '',
                warehouseCurrent: '',
                warehouseNew: '',
                note: '',
                statusCurrent: '',
            },
            lstLocation: [],
            lstDepartment: [],
            lstFixedAssets: [],
            lstWarehouse: [],
        };
    },

    created() {
        const self = this;
        const role = parseInt(this.$store.state.auth.user.role);
        
        this.createItem.userCreateId = this.$store.state.auth.user.userId;
        
        const queryParam = this.$route.query;

        if (queryParam.isPrint != undefined && queryParam.isPrint == 1) {
            this.isPrint = true;
        }

        if (queryParam.tranferId != undefined) {
            this.getTranferItem(queryParam.tranferId);
        }

        this.getWarehouse();
        this.getLocation();
        this.getDepartment();
        this.getFixedAssets();

        if (this.isPrint) {
            setTimeout(function(){
                self.onPrint();
            }, 2000);
        }
        
    },
    computed: {
        isUpdate() {
            if (this.createItem.id != undefined && parseInt(this.createItem.id) > 0) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        onCancel() {
            const query = this.$route.query;
            if (query.backTo != undefined && query.backTo == 'fixedAssetsReport') {
                this.$router.push({ path: `/fixedAssetsReport`, query: query });
            } else {
                this.$router.push({ path: `/fixedAssetsTranfer`, query: query });
            }
        },
        onSave() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
               
                // console.log(this.createItem);
                // return;
                this.loading = true;
                axios
                    .post(process.env.VUE_APP_API_URL + "/fixedAssetsTranfer/save", this.createItem)
                    .then(
                        (data) => {
                            if (data.success) {
                                
                                if (this.isPrint) {
                                    this.onViewPrint(data.id);
                                } else {
                                    message.success(
                                        this.$t("lang.common.save_success")
                                    );
                                    this.onCancel();
                                }
                                
                            } else {
                                message.error(this.$t(data.description));
                            }
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            console.log(error);
                        }
                    );
            });
        },
        onSavePrint() {
            this.isPrint = true;
            this.onSave();
        },
        onViewPrint(tranferId = 0) {
            this.$router.push({path: '/fixedAssetsTranfer/view', query: {tranferId: tranferId, isPrint: 1} });
        },
        onPrint() {
            window.print();
        },
        getTranferItem(tranferId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/fixedAssetsTranfer/search?pageSize=-1&page=-1", {id: tranferId}
            ).then(
                (data) => {
                    if (data.items) {
                        this.createItem = data.items[0];
                        this.fixedAssetsName = this.createItem.name;
                    }
                }
            );
        },
        getLocation(parentId = 0) {
            let url = process.env.VUE_APP_API_URL + "/category/listByType?type=OFFICE_LOCATION";
            if (parentId > 0) {
                url += "&parentId=" + parentId;
            }
            axios.post(
                url
            ).then(
                (data) => {
                    if (data.length > 0) {
                        this.lstLocation = data;
                    }
                }
            );
        },
        getDepartment() {
            axios.post(
                process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {}
            ).then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                    }
                }
            );
        },
        getFixedAssets() {
            axios.post(
                process.env.VUE_APP_API_URL + "/fixedAssets/search?pageSize=-1&page=-1",
                { status: 1 }
            )
            .then((data) => {
                if (data.items) {
                    this.lstFixedAssets = data.items;
                }
            });
        },
        getWarehouse() {
            axios.post(
                process.env.VUE_APP_API_URL +
                "/category/listByType?type=WAREHOUSE&description=1"
            )
                .then((data) => {
                    if (data.length > 0) {
                        this.lstWarehouse = data;
                    }
                });
        },
        onChangeFixedAssets(event) {
            const item = this.lstFixedAssets.find(o => o.id === event );
            if (item !== undefined && typeof item == 'object') {
                this.setInfo(item);
            }
        },
        setInfo(item) {
            this.fixedAssetsName = item.name;
            this.createItem.fixedAssetsId = item.id;
            
            if (item.locationId != null) {
                this.setLocationName(item.locationId);
            }

            if (item.departmentId != null) {
                this.setDepartmentName(item.departmentId);
            }

            if (item.warehouseId != null) {
                this.setWarehouseName(item.warehouseId);
            }
        },
        setLocationName(locationId) {
            const location = this.lstLocation.find(o => o.categoryId === locationId );
            if (location !== undefined && typeof location == 'object') {
                this.createItem.locationCurrent = location.categoryId;
            }
        },
        setDepartmentName(departmentId) {
            const department = this.lstDepartment.find(o => o.deptId === departmentId );
            if (department !== undefined && typeof department == 'object') {
                this.createItem.departmentCurrent = department.deptId;
            }
        },
        setWarehouseName(warehouseId) {
            const warehouse = this.lstWarehouse.find(o => o.categoryId === warehouseId );
            if (warehouse !== undefined && typeof warehouse == 'object') {
                this.createItem.warehouseCurrent = warehouse.categoryId;
            }
        },
        getFixedAssetsName() {
            const fixedAssets = this.lstFixedAssets.find(o => o.id === this.createItem.fixedAssetsId );
            if (fixedAssets !== undefined && typeof fixedAssets == 'object') {
                return fixedAssets.name;
            } else {
                return '';
            }
        },
        getFixedAssetsCode() {
            const fixedAssets = this.lstFixedAssets.find(o => o.id === this.createItem.fixedAssetsId );
            if (fixedAssets !== undefined && typeof fixedAssets == 'object') {
                return fixedAssets.code;
            } else {
                return '';
            }
        },
        getLocationName(locationId) {
            const location = this.lstLocation.find(o => o.categoryId === locationId );
            if (location !== undefined && typeof location == 'object') {
                return location.categoryName;
            } else {
                return '';
            }
        },
        getDepartmentName(departmentId) {
            const department = this.lstDepartment.find(o => o.deptId === departmentId );
            if (department !== undefined && typeof department == 'object') {
                return department.deptName;
            } else {
                return '';
            }
        },
        getWarehouseName(warehouseId) {
            const warehouse = this.lstWarehouse.find(o => o.categoryId === warehouseId );
            if (warehouse !== undefined && typeof warehouse == 'object') {
                return warehouse.categoryName;
            } else {
                return '';
            }
        },
        onChangeWh(warehouseId) {
            const warehouse = this.lstWarehouse.find((v) => v.categoryId === warehouseId);
            if (warehouse != undefined) {
                this.getLocation(warehouse.parentId);
            }
        },
        formatDate(date) {
            return date ? moment(String(date)).format('YYYY-MM-DD') : '';
        },
    },

    destroyed() {},
};
</script>
